import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getDeMobilizationNew = createAsyncThunk("api/Demobilization", async (token) => {
  try {
    const response = await nodeinstance.get("/mobilization/demobilize", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const DeMobilizationDataSlice = createSlice({
  name: "Demobilization",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDeMobilizationNew.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getDeMobilizationNew.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getDeMobilizationNew.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getDeMobilizationNew };
export default DeMobilizationDataSlice.reducer;
